import React from "react";
import ReactHtmlParser from "react-html-parser";

export default function IndicatorsBox(props) {
  const extraKey = props?.extraKey ?? "";
  let action = "";
  const Buy = () => <button className="btn btn-sm btn-success"> Buy</button>;
  const Sell = () => <button className="btn btn-sm btn-danger"> Sell</button>;
  const Neutral = () => (
    <button className="btn btn-sm btn-info"> Neutral</button>
  );
  const ltp = parseFloat(props?.ltp);
  const currValue = parseFloat(props?.currValue);
  const high = parseFloat(props?.high);
  const preLow = parseFloat(props?.preLow);
  const middleBand = parseFloat(props?.middleBand);
  const preValue = parseFloat(props?.preValue);
  const oldKper = parseFloat(props?.oldKper);
  const CurrKPer = parseFloat(props?.CurrKPer);

  if (extraKey !== "") {
    if (extraKey === "SMA") {
      if (ltp > currValue) {
        action = <Buy />;
      } else {
        action = <Sell />;
      }
    } else if (extraKey === "RSI") {
      if (currValue > preValue && currValue > 30) {
        action = <Buy />;
      } else if (currValue < preValue && currValue < 30) {
        action = <Sell />;
      } else {
        action = <Neutral />;
      }
    } else if (extraKey === "Supertrend") {
      if (ltp > high) {
        action = <Buy />;
      } else if (ltp < preLow) {
        action = <Sell />;
      } else {
        action = <Neutral />;
      }
    } else if (extraKey === "BBRANDS") {
      if (ltp > middleBand) {
        action = <Buy />;
      } else if (ltp < middleBand) {
        action = <Sell />;
      } else {
        action = <Neutral />;
      }
    } else if (extraKey === "STOCH") {
      if (CurrKPer > oldKper) {
        action = <Buy />;
      } else if (CurrKPer < oldKper) {
        action = <Sell />;
      } else {
        action = <Neutral />;
      }
    } else {
      if (currValue > preValue) {
        action = <Buy />;
      } else if (currValue < preValue) {
        action = <Sell />;
      } else {
        action = <Neutral />;
      }
    }
  }
  return (
    <tr>
      <td>{ReactHtmlParser(props?.keys)}</td>
      <td> {preValue} </td>
      <td>{currValue}</td>
      <td className="text-center">{action}</td>
    </tr>
  );
}
